import { EOrderPaymentProviderType } from "../../Enum/EOrderPaymentProviderType"

export class OrderPaymentProvider {
  providerType: EOrderPaymentProviderType

  isEnabled: boolean

  isOnlinePaymentEnabled: boolean

  isInPersonPaymentEnabled: boolean

  isTapToPayEnabled: boolean

  hasCredentials: boolean

  supportedCapabilities: string[]

  constructor(data: Partial<OrderPaymentProvider> = {}) {
    this.providerType = data.providerType ?? EOrderPaymentProviderType.None

    this.isEnabled = data.isEnabled ?? false

    this.isOnlinePaymentEnabled = data.isOnlinePaymentEnabled ?? false

    this.isInPersonPaymentEnabled = data.isInPersonPaymentEnabled ?? false

    this.isTapToPayEnabled = data.isTapToPayEnabled ?? false

    this.hasCredentials = data.hasCredentials ?? false

    this.supportedCapabilities = data.supportedCapabilities ?? []
  }

  supports(capability: "OnlinePayment" | "InPersonPayment" | "TapToPay" | "Split"): boolean {
    return this.supportedCapabilities.includes(capability)
  }
}
